export const baseUrl = {
    Base_Url: "https://balanceonlife.developer-oa.xyz/api",
    Image_Url: "https://balanceonlife.developer-oa.xyz/"
}